import { gql } from '@apollo/client';

export const getChannelPlatformToken = gql`
  query channelPlatformToken {
    supportInquiry_channelsIdentityHash
  }
`;

export const getChannelPlatformTokenByClientName = gql`
  query channelPlatformTokenGenerationByClientName($clientName: String) {
    supportInquiry_channelsIdentityHashByClientName(request: { clientName: $clientName })
  }
`;

export const getCustomerConversations = gql`
  query CustomerConversations($anonymousId: String) {
    channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
      conversations
    }
  }
`;
